<template>
  <div class="flex-col h-full relative">
    <router-view v-if="ready" />
    <div v-else class="flex items-center justify-center h-full">
      <AnimatedSprite class="h-48 w-48" sprite-id="loading-logo" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useDesignerBranding } from '/@/data/designer/branding'
import { computed, watch } from 'vue'
import { useCurrentDesigner } from '../data/designer/current'

const { nickname: inNickname } = defineProps<{
  nickname: string
}>()
const designerBranding = useDesignerBranding()
const { designer } = useCurrentDesigner()

const nickname = computed(() =>
  inNickname === 'me' ? designer.value?.nickname : inNickname,
)

watch(
  nickname,
  n => {
    if (n) {
      designerBranding.fetch({ nickname: n })
    }
  },
  { immediate: true },
)

const ready = computed(() => {
  return Boolean(designerBranding.id)
})
</script>

<style lang="scss" scoped></style>
